<section [class]="panelClasses()">
  @if (showHeader()) {
    <header [class]="headerClasses()">
      <div [class]="titleClasses()">
        <ng-content select="[accordionTitle]" />
      </div>
      <div class="inline-flex flex-wrap items-center gap-1.5 empty:hidden"><ng-content select="[accordionActions]" />@if (collapsible()) {
          <button
            class="accordion__toggle"
            libButton
            variant="chip"
            size="icon"
            [attr.aria-expanded]="!isCollapsed()"
            aria-label="Toggle section"
            (click)="togglePanelCollapse()">
            <svg viewBox="0 0 24 24" aria-hidden="true" [class]="toggleIconClasses()">
              <path
                d="M8 10l4 4 4-4"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        }
      </div>
    </header>
  }

  @if (collapsible() && isCollapsed() && collapsedPlaceholder()) {
    <p [class]="emptyClasses()">
      <ng-content select="[accordionCollapsed]" />
    </p>
  }

  <div [class]="metaClasses()">
    <ng-content select="[accordionMeta]" />
  </div>

  <div
    class="accordion__body"
    [class]="wrapsBody() ? bodyClasses() : ''"
    [hidden]="collapsible() && isCollapsed()">
    <ng-content />
  </div>
</section>
